import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ScreeningStatus, StockData } from '../../types';

const initialState: ScreeningStatus = {
  status: 'idle',
  current_stock: '',
  processed_count: 0,
  total_stocks: 0,
  passing_count: 0,
  failed_count: 0,
  error_count: 0,
  message: '',
  results: [],
  last_updated: null,
};

const screeningSlice = createSlice({
  name: 'screening',
  initialState,
  reducers: {
    setScreeningStatus: (state, action: PayloadAction<Partial<ScreeningStatus>>) => {
      return { ...state, ...action.payload };
    },
    setScreeningResults: (state, action: PayloadAction<StockData[]>) => {
      state.results = action.payload;
      state.last_updated = new Date().toISOString();
    },
    setLastUpdated: (state, action: PayloadAction<string>) => {
      state.last_updated = action.payload;
    },
    resetScreening: () => initialState,
  },
});

export const { setScreeningStatus, setScreeningResults, setLastUpdated, resetScreening } = screeningSlice.actions;
export default screeningSlice.reducer; 